import { createCookie, readCookie } from '../cookieUtils';
import modalProposalTemplate from '../../view/angular/common/modal/modal-proposal.tpl.html';
import jrModalCloseTemplate from '../../view/angular/common/modal/modal-close.tpl.html';
import jrGdprModalTemplate from '../../view/angular/common/modal/gdpr-modal.tpl.html';
import modalMySearchesProposalTemplate from '../../view/angular/common/modal/modal-my-searches-proposal.tpl.html';
import modalConfirmSubscriptionTemplate from '../../view/angular/common/modal/modal-confirm-subscription.tpl.html';
import modalSubscriptionErrorTemplate from '../../view/angular/common/modal/modal-subscription-error.tpl.html';
import modalLinkToInboxConfirmSubscriptionTemplate from '../../view/angular/common/modal/modal-link-to-inbox-confirm-subscription.tpl.html';
import modalSocialSubscriptionErrorTemplate from '../../view/angular/common/modal/modal-social-subscription-error.tpl.html';
import modalProposalJppTemplate from '../../view/angular/common/modal/modal-proposal-jpp.tpl.html';

angular
  .module('jrModal', ['jrConfig', 'jrAutocompleteEmail', 'jrUtil', 'jrEvents'])
  .value('createCookie', createCookie)
  .value('readCookie', readCookie)
  .value('modalProposalTemplate', modalProposalTemplate)
  .value('jrModalCloseTemplate', jrModalCloseTemplate)
  .value('jrGdprModalTemplate', jrGdprModalTemplate)
  .value('modalMySearchesProposalTemplate', modalMySearchesProposalTemplate)
  .value('modalConfirmSubscriptionTemplate', modalConfirmSubscriptionTemplate)
  .value('modalSubscriptionErrorTemplate', modalSubscriptionErrorTemplate)
  .value('modalProposalJppTemplate', modalProposalJppTemplate)
  .value('modalSocialSubscriptionErrorTemplate', modalSocialSubscriptionErrorTemplate)
  .value('modalLinkToInboxConfirmSubscriptionTemplate', modalLinkToInboxConfirmSubscriptionTemplate)
  .factory('ModalProposalTemplateLoaderService', [
    '$compile',
    function ($compile) {
      function loadTemplate(scope, element, template) {
        if (!element) {
          return;
        }

        element.innerHTML = template;
        $compile(element)(scope);
      }

      return {
        loadTemplate,
      };
    },
  ])
  .factory('ModalProposalService', [
    '$modal',
    'modalProposalTemplate',
    'ModalConfig',
    'PagesConfig',
    'modalProposalJppTemplate',
    function ($modal, modalProposalTemplate, ModalConfig, PagesConfig, modalProposalJppTemplate) {
      function openModal(modalOptions) {
        modalOptions.backdropClass = `opacity-${ModalConfig.overlayOpacity}`;
        return $modal.open(modalOptions);
      }

      return {
        openModal,
        openModalProposal(modalOptions) {
          return openModal(
            angular.extend(
              {
                template: PagesConfig.isJobPreviewPage
                  ? modalProposalJppTemplate
                  : modalProposalTemplate,
                controller: 'ModalProposalCtrl',
              },
              modalOptions
            )
          );
        },
      };
    },
  ])
  .controller('ModalProposalCtrl', [
    'Messages',
    'AutocompleteEmailConfig',
    'SearchDistanceConfig',
    'SocialLoginConfig',
    'SubscriptionService',
    'LinkToInboxService',
    'OpenTabService',
    'ModalProposalTemplateLoaderService',
    'EventsService',
    'GoogleTagManagerTrackingService',
    'SubscriptionConfig',
    'SearchConfig',
    'search',
    '$timeout',
    '$scope',
    '$rootScope',
    '$window',
    'modalLinkToInboxConfirmSubscriptionTemplate',
    'modalMySearchesProposalTemplate',
    'modalSubscriptionErrorTemplate',
    'modalSocialSubscriptionErrorTemplate',
    'modalConfirmSubscriptionTemplate',
    function (
      Messages,
      AutocompleteEmailConfig,
      SearchDistanceConfig,
      SocialLoginConfig,
      SubscriptionService,
      LinkToInboxService,
      OpenTabService,
      ModalProposalTemplateLoaderService,
      EventsService,
      GoogleTagManagerTrackingService,
      SubscriptionConfig,
      SearchConfig,
      search,
      $timeout,
      $scope,
      $rootScope,
      $window,
      modalLinkToInboxConfirmSubscriptionTemplate,
      modalMySearchesProposalTemplate,
      modalSubscriptionErrorTemplate,
      modalSocialSubscriptionErrorTemplate,
      modalConfirmSubscriptionTemplate
    ) {
      $scope.messages = Messages;
      $scope.autocompleteEnabled = AutocompleteEmailConfig.enabled;
      $scope.distanceFilterEnabled = SearchDistanceConfig.enabled;
      $scope.socialLoginEnabled = SocialLoginConfig.enabled;
      $scope.socialLoginMultipleNetworksEnabled = SocialLoginConfig.multiple;
      $scope.socialLoginLinkedinEnabled = SocialLoginConfig.linkedin;
      $scope.search = search;
      $scope.isEmptySearch = search.isEmptySearch;
      $scope.isSubscriptionCaptchaEnabled = SearchConfig.isSubscriptionCaptchaEnabled;
      $scope.hasBeenSubmitted = false;
      $scope.buttonAdditionalClass = SubscriptionConfig.buttonAdditionalClass;
      $scope.totalResults = SearchConfig.totalResults;
      $scope.mySearches = [
        {
          what: $scope.search.what,
          where: $scope.search.where,
        },
        {
          what: undefined,
          where: undefined,
        },
        {
          what: undefined,
          where: undefined,
        },
      ];
      $scope.jobseeker = {};
      $scope.forms = {};
      $scope.loading = true;
      $scope.search.where = SearchConfig.whereByIp || search.where;
      $scope.locationFieldInModalPopupEnabled = SearchConfig.locationFieldInModalPopupEnabled;

      let linkToInboxProviders = [];

      function afterSubscription(result) {
        const statusCreated = result.status === 201;
        const statusConflict = result.status === 409;
        const modalSkeleton = document.querySelector('.js-modal-skeleton');

        $scope.loading = false;
        if (statusCreated || statusConflict) {
          // After subscription callback
          GoogleTagManagerTrackingService.trackAutoSubscription($scope.jobseeker.email);
          // Emitting the subscription sent event
          EventsService.emit.subscriptionSent({
            type: 'modal',
            email: $scope.jobseeker.email,
          });

          linkToInboxProviders = LinkToInboxService.findProvider($scope.jobseeker.email);

          if (linkToInboxProviders.length) {
            ModalProposalTemplateLoaderService.loadTemplate(
              $scope,
              modalSkeleton,
              modalLinkToInboxConfirmSubscriptionTemplate
            );
            return;
          }

          GoogleTagManagerTrackingService.trackAddMoreStatement();
          ModalProposalTemplateLoaderService.loadTemplate(
            $scope,
            modalSkeleton,
            modalMySearchesProposalTemplate
          );
        } else {
          ModalProposalTemplateLoaderService.loadTemplate(
            $scope,
            modalSkeleton,
            modalSubscriptionErrorTemplate
          );
        }
      }

      function afterSocialSubscription(result, source) {
        const statusCreated = result.status === 201;
        const statusConflict = result.status === 409;

        $scope.loading = false;
        if (statusCreated) {
          GoogleTagManagerTrackingService.trackSocialAutoSubscription(
            source,
            $scope.jobseeker.email
          );
        }
        if (statusCreated || statusConflict) {
          $window.location.href = result.headers('activateUrl');
        }
      }

      function afterAddMySearches(result) {
        const statusOK = result.status >= 200 && result.status < 300;
        const modalSkeleton = document.querySelector('.js-modal-skeleton');

        $scope.loading = false;

        if (statusOK) {
          ModalProposalTemplateLoaderService.loadTemplate(
            $scope,
            modalSkeleton,
            modalConfirmSubscriptionTemplate
          );
        } else {
          ModalProposalTemplateLoaderService.loadTemplate(
            $scope,
            modalSkeleton,
            modalSubscriptionErrorTemplate
          );
        }
      }

      $scope.$watchCollection('search', function (newValue) {
        $scope.mySearches[0] = {
          what: newValue.what,
          where: newValue.where,
        };

        if ($scope.forms && $scope.forms.proposal) {
          $scope.forms.proposal.$setValidity('searchParams', !!newValue.what || !!newValue.where);
        }
      });

      $scope.submitSubscription = function (e) {
        $scope.hasBeenSubmitted = true;
        let captchaUserResponse;

        if (SearchConfig.isSubscriptionCaptchaEnabled) {
          captchaUserResponse = grecaptcha.getResponse($rootScope.SubscriptionModalCaptcha);
          $scope.captchaUserResponseOk =
            captchaUserResponse !== undefined && captchaUserResponse.length !== 0;
          if (!$scope.captchaUserResponseOk) {
            grecaptcha.reset($rootScope.SubscriptionModalCaptcha);
            return;
          }
        }

        if (!$scope.forms.proposal.$valid) {
          return;
        }
        $scope.loading = true;

        if ($scope.locationFieldInModalPopupEnabled && !$scope.isEmptySearch) {
          dataLayer.push({
            event: 'subscription.modal.where.by.ip.input.value',
            isWhereByIpEmptyInSubscriptionModal: !$scope.search.where,
          });
        }

        // Subscribing
        SubscriptionService.subscribe(
          $scope.jobseeker.email,
          $scope.search,
          '',
          '',
          '',
          '',
          '',
          '',
          captchaUserResponse
        ).then(afterSubscription, afterSubscription);
        e.preventDefault();
      };

      $scope.submitSocialSubscription = function (e, source) {
        $scope.hasBeenSubmitted = true;
        $scope.isSocialLogin = true;
        if ($scope.forms.proposal.$error.searchParams) {
          return;
        }

        if (source === 'facebook') {
          FB.login(
            function (response) {
              if (response.status === 'connected') {
                FB.api(
                  '/me',
                  {
                    fields: 'last_name, first_name, email',
                  },
                  function (response) {
                    if (typeof response.email === 'undefined') {
                      ModalProposalTemplateLoaderService.loadTemplate(
                        $scope,
                        document.querySelector('.js-modal-skeleton'),
                        modalSocialSubscriptionErrorTemplate
                      );
                    } else {
                      $scope.jobseeker.email = response.email;
                      $scope.jobseeker.firstName = response.first_name;
                      $scope.jobseeker.lastName = response.last_name;
                      // Subscribing
                      SubscriptionService.subscribe(
                        $scope.jobseeker.email,
                        $scope.search,
                        'facebook',
                        '',
                        '',
                        'pop-up',
                        $scope.jobseeker.firstName,
                        $scope.jobseeker.lastName
                      ).then(
                        function (result) {
                          afterSocialSubscription(result, source);
                        },
                        function (result) {
                          afterSocialSubscription(result, source);
                        }
                      );
                    }
                  }
                );
              }
            },
            {
              scope: 'public_profile, email',
              auth_type: 'rerequest',
            }
          );
        } else if (source === 'google') {
          auth2
            .signIn({
              scope: 'profile email',
            })
            .then(function (googleUser) {
              const userProfile = googleUser.getBasicProfile();
              $scope.jobseeker.email = userProfile.getEmail();
              $scope.jobseeker.firstName = userProfile.getGivenName();
              $scope.jobseeker.lastName = userProfile.getFamilyName();
              // Subscribing
              SubscriptionService.subscribe(
                $scope.jobseeker.email,
                $scope.search,
                'google',
                '',
                '',
                'pop-up',
                $scope.jobseeker.firstName,
                $scope.jobseeker.lastName
              ).then(
                function (result) {
                  afterSocialSubscription(result, source);
                },
                function (result) {
                  afterSocialSubscription(result, source);
                }
              );
            });
        } else if (source === 'linkedin') {
          IN.User.authorize(function () {
            if (IN.User.isAuthorized()) {
              IN.API.Profile('me')
                .fields([
                  'firstName',
                  'lastName',
                  'industry',
                  'location:(name)',
                  'picture-url',
                  'email-address',
                  'educations',
                  'date-of-birth',
                ])
                .result(function (profile) {
                  const userProfile = profile.values[0];
                  $scope.jobseeker.email = userProfile.emailAddress;
                  $scope.jobseeker.firstName = userProfile.firstName;
                  $scope.jobseeker.lastName = userProfile.lastName;
                  // Subscribing
                  SubscriptionService.subscribe(
                    $scope.jobseeker.email,
                    $scope.search,
                    'linkedin',
                    '',
                    '',
                    'pop-up',
                    $scope.jobseeker.firstName,
                    $scope.jobseeker.lastName
                  ).then(
                    function (result) {
                      afterSocialSubscription(result, source);
                    },
                    function (result) {
                      afterSocialSubscription(result, source);
                    }
                  );
                });
            }
          });
        }

        e.preventDefault();
      };

      $scope.submitMySearches = function (e) {
        $scope.loading = true;
        // Adding my searches
        SubscriptionService.addMySearches(
          $scope.jobseeker.email,
          angular.copy($scope.mySearches).slice(1, 3)
        ).then(afterAddMySearches, afterAddMySearches);
        e.preventDefault();
      };

      $scope.submitOneSearch = function (e) {
        const srchs = angular.copy($scope.mySearches);
        $scope.loading = true;
        // Adding my searches
        SubscriptionService.addMySearches($scope.jobseeker.email, [srchs[0], {}, {}]).then(
          afterAddMySearches,
          afterAddMySearches
        );
        e.preventDefault();
      };

      $scope.openLinkToInboxProvider = function (e) {
        if (linkToInboxProviders.length) {
          OpenTabService.open(linkToInboxProviders[0].url);
        }
        $scope.$close();
        e.preventDefault();
      };

      $timeout(function () {
        $scope.loading = false;
      });
    },
  ])
  .directive('jrModalClose', [
    'jrModalCloseTemplate',
    function (jrModalCloseTemplate) {
      return {
        replace: true,
        template: jrModalCloseTemplate,
      };
    },
  ])
  .directive('jrGdprModal', [
    'ModalProposalService',
    'Messages',
    '$rootScope',
    '$http',
    'JobseekerConfig',
    'jrGdprModalTemplate',
    function (
      ModalProposalService,
      Messages,
      $rootScope,
      $http,
      JobseekerConfig,
      jrGdprModalTemplate
    ) {
      return {
        link(scope) {
          scope.messages = Messages;
          scope.gdprModalError = false;
          $rootScope.gdprModalEnabled = true;
          scope.isAlreadyClicked = false;

          scope.openGdprModal = ModalProposalService.openModal({
            template: jrGdprModalTemplate,
            windowClass: 'gdpr-modal',
            backdrop: 'static',
          });

          scope.closeModal = function (event) {
            if (!scope.isAlreadyClicked) {
              scope.isAlreadyClicked = true;
              $http
                .get('/privacy-policy/change', {
                  params: {
                    jobseeker_id: JobseekerConfig.id,
                    from: 'banner',
                    core_services_accepted: true,
                    job_marketing_accepted: true,
                  },
                })
                .then(
                  function (response) {
                    jtag('event', 'privacy_policy_accept_client', {
                      event_label: event,
                    });

                    scope.openGdprModal.close();
                    $rootScope.gdprModalEnabled = false;
                    scope.gdprModalError = false;
                  },
                  function (response) {
                    scope.gdprModalError = true;
                    scope.isAlreadyClicked = false;
                  }
                );
            }
          };

          jtag('event', 'privacy_policy_impression_client');
        },
      };
    },
  ])
  .factory('ConfirmationMailSender', [
    '$http',
    function ($http) {
      function send() {
        return $http({
          method: 'GET',
          url: '/public/api/unconfirmed-jobseeker/send-confirmation',
        });
      }

      return {
        send,
      };
    },
  ])
  .directive('jrConfirmReminderModal', [
    'Messages',
    'ModalProposalService',
    'JobseekerConfig',
    'LinkToInboxService',
    'OpenTabService',
    'ConfirmReminderModalService',
    'modalLinkToInboxConfirmSubscriptionTemplate',
    'ConfirmationMailSender',
    function (
      Messages,
      ModalProposalService,
      JobseekerConfig,
      LinkToInboxService,
      OpenTabService,
      ConfirmReminderModalService,
      modalLinkToInboxConfirmSubscriptionTemplate,
      ConfirmationMailSender
    ) {
      return {
        link(scope) {
          if (ConfirmReminderModalService.isVisible()) {
            jtag('event', 'confirm_reminder_modal_impression_client');

            ConfirmReminderModalService.initCookie();

            const modal = ModalProposalService.openModal({
              template: modalLinkToInboxConfirmSubscriptionTemplate,
              windowClass: 'confirm-reminder-modal',
              scope,
              backdrop: true,
            });

            scope.jobseeker = {
              email: JobseekerConfig.email,
            };
            scope.messages = Messages;
            scope.openLinkToInboxProvider = function (e) {
              e.preventDefault();

              ConfirmationMailSender.send();

              const linkToInboxProviders = LinkToInboxService.findProvider(scope.jobseeker.email);

              if (linkToInboxProviders.length) {
                OpenTabService.open(linkToInboxProviders[0].url);
              }

              jtag('event', 'confirm_reminder_modal_click_button');

              modal.close();
            };
          }
        },
      };
    },
  ])
  .factory('ConfirmReminderModalService', [
    'createCookie',
    'readCookie',
    function (createCookie, readCookie) {
      const cookieName = 'confirmReminderModalCount';
      const cookieExpireDays = 30;

      function isVisible() {
        const popupMaxCount = jrConfigGlobal.modal.confirmReminderMaxTimes;
        const count = readConfirmReminderCookie(cookieName);

        return parseInt(count, 10) < popupMaxCount;
      }

      function initCookie() {
        const cookieValue = readConfirmReminderCookie(cookieName);

        createCookie(cookieName, parseInt(cookieValue, 10) + 1, cookieExpireDays);
      }

      function readConfirmReminderCookie(cookieName) {
        return readCookie(cookieName) || 0;
      }

      return {
        isVisible,
        initCookie,
      };
    },
  ]);
